'use client';

import HeroBackground from '~/components/marketing/sections/new-hero/background';

export default function LegalPagesLayout({
  children,
}: React.PropsWithChildren) {
  return (
    <section
      id="hero"
      className="relative mx-auto flex w-full flex-col items-center justify-start overflow-x-clip px-6 pt-[137px] lg:px-8 lg:pt-36"
    >
      <HeroBackground />
      <div className="z-30 flex w-full max-w-[747px] flex-col items-start gap-[32px] pb-[162px] pt-[40px] text-white">
        {children}
      </div>
    </section>
  );
}
